import { useEffect } from "react";
import { api } from "@/api";
import { getBuyerAuthToken } from "@/api/token";
import { useProfile } from "@/store/profile";
import { useWishlist } from "@/store/wishlist";
import {
	markShopInviteAttempted,
	markShopInviteVisited,
	readShopInvite,
	readShopInviteMeta,
	shopInviteBindPendingFor,
	shopInviteVisitPending,
} from "./shop-invite";

/**
 * Переход по ссылке магазина и привязка вошедшего покупателя к магазину.
 * Для покупателя ничего не меняется - ни экранов, ни сообщений: льгота -
 * это комиссия продавца. Ошибки глотаем: привязка не должна мешать покупке.
 */
export function useShopInvite(): void {
	const clientId = useWishlist((s) => s.clientId);
	const token = useProfile((s) => s.token);

	useEffect(() => {
		const code = readShopInvite();
		if (!code || !shopInviteVisitPending() || !clientId) return;
		api.shopInvite
			.visit(code, clientId, readShopInviteMeta())
			.then(markShopInviteVisited)
			.catch(() => undefined);
	}, [clientId]);

	useEffect(() => {
		if (!token || !getBuyerAuthToken()) return;
		const key = token.slice(-12);
		const code = shopInviteBindPendingFor(key);
		if (!code) return;
		api.shopInvite
			.bind(code, clientId || undefined)
			.then(() => markShopInviteAttempted(key))
			.catch(() => undefined);
	}, [token, clientId]);
}
